import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { payDirect } from 'services/api/Order';
import Button from '@mui/material/Button';
import "./DirectPayment.scss";

const DirectPayment = () => {
    const location = useLocation();
    const [orderInfo, setOrderInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [urlSuccess, setUrlSuccess] = useState("");
    const [urlFailure, setUrlFailure] = useState("");

    // Récupère l'id directement du query string (sans paramètre nommé)
    const id = location.search ? location.search.substring(1) : null;

    const load = async () => {
        if (!id) {
            setError("Identifiant de paiement manquant");
            setLoading(false);
            return;
        }

        const result = await payDirect(id);

        if (result?.ok && !result.content?.error) {
            setOrderInfo(result.content);
        } else {
            setError(result.content?.message || result?.errMsg || "Une erreur est survenue");
        }
        setLoading(false);
    };

    useEffect(() => {
        setUrlSuccess(`${window.location.origin}/order/pay/success`);
        setUrlFailure(`${window.location.origin}/order/pay/failure`);
        load();
    }, []);

    if (loading) {
        return (
            <div className="direct-payment">
                <div className="direct-payment-container">
                    <div className="loading">
                        <i className="fas fa-spinner fa-spin fa-lg"></i>
                        <p>Chargement...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="direct-payment">
                <div className="direct-payment-container">
                    <div className="error-message">
                        <i className="fas fa-exclamation-circle fa-2x"></i>
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="direct-payment">
            <div className="direct-payment-container">
                {orderInfo && (
                    <>
                        <h2>{orderInfo.title || "Paiement"}</h2>
                        <div className="order-info">
                            {orderInfo.details && (
                                <div className="info-details" dangerouslySetInnerHTML={{ __html: orderInfo.details }} />
                            )}
                            <div className="info-row total">
                                <span className="label">Montant à régler :</span>
                                <span className="value">{orderInfo.toPay} €</span>
                            </div>
                        </div>

                        {orderInfo.form && orderInfo.fields && (
                            <form action={orderInfo.form.action} method={orderInfo.form.method} acceptCharset={orderInfo.form["accept-charset"]}>
                                {Object.entries(orderInfo.fields)
                                    .filter(f => (f[0] !== "vads_url_success" && f[0] !== "vads_url_return"))
                                    .map((field, index) => (
                                        <input key={index} type="hidden" name={field[0]} value={field[1]} />
                                    ))}
                                <input type="hidden" name="vads_url_success" value={urlSuccess} />
                                <input type="hidden" name="vads_url_return" value={urlFailure} />
                                <div className="payment-buttons">
                                    <Button
                                        style={{fontSize: '16px', marginTop: '20px'}}
                                        variant="contained"
                                        type="submit"
                                    >
                                        Payer par carte bancaire
                                    </Button>
                                </div>
                            </form>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default DirectPayment;
